// src/component/Pages/Editprofile.jsx

import React, { useState } from "react";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  Box
} from "@mui/material";
import Person2Icon from "@mui/icons-material/Person2";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import TodayIcon from "@mui/icons-material/Today";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { axiosInstance } from "../Api/instance";
import { useNavigate } from "react-router-dom";
import { PrimaryButton, SecondaryButton } from "../ui/Buttons";
import { styled } from "@mui/material/styles";

const FormCard = styled(Paper)(({ theme }) => ({
  borderRadius: "24px",
  padding: "36px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
  width: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
}));

const FormLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: "0.875rem",
  marginBottom: "8px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
}));

const Editprofile = () => {
  const navigate = useNavigate();
  const [gender, setGender] = useState("");
  const [qualification, setQualification] = useState("");
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [date, setDate] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const email = localStorage.getItem("userMail");

  const nameChange = (e) => setName(e.target.value);
  const numberChange = (e) => setNumber(e.target.value);
  const dateChange = (e) => setDate(e.target.value);
  const monthChange = (e) => setMonth(e.target.value);
  const yearChange = (e) => setYear(e.target.value);

  const handleGenderChange = (event) => setGender(event.target.value);
  const handleQualificationChange = (event) => setQualification(event.target.value);

  const handleClickOpen = async () => {
    try {
      const response = await axiosInstance.post(`put/U_updateStudent.php`, {
        email: email,
        username: name,
        mobileno: number,
        dob: [year, month, date],
        gender: gender,
        qualification: qualification,
      });
      setName("");
      setNumber("");
      setGender("");
      setDate("");
      setMonth("");
      setYear("");
      setQualification("");
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
          return;
        }
        navigate("/home");
      }
    } catch (error) {
      console.error("Error updating student profile:", error);
    }
  };

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const currentYear = new Date().getFullYear();
  const startYear = 1990;

  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => currentYear - index
  );

  const CancelBtn = () => {
    navigate("/home");
  };

  return (
    <FormCard>
      <Box style={{ textAlign: "center", marginBottom: "28px" }}>
        <Typography variant="h2" style={{ fontWeight: 800 }}>
          Edit Profile Information
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: "4px" }}>
          Update your student registration details
        </Typography>
      </Box>

      <form style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        
        {/* Full Name */}
        <Box>
          <FormLabel>
            Full Name
            <Person2Icon fontSize="inherit" color="action" />
          </FormLabel>
          <TextField
            fullWidth
            id="fullName"
            size="medium"
            onChange={nameChange}
            value={name}
            placeholder="Enter full name"
            required
            InputProps={{ style: { borderRadius: "14px" } }}
          />
        </Box>

        {/* Mobile Number */}
        <Box>
          <FormLabel>
            Mobile Number
            <PhoneIphoneIcon fontSize="inherit" color="action" />
          </FormLabel>
          <TextField
            fullWidth
            id="mobileNumber"
            size="medium"
            onChange={numberChange}
            value={number}
            placeholder="Enter mobile number"
            required
            InputProps={{ style: { borderRadius: "14px" } }}
          />
        </Box>

        {/* Date of Birth Grid */}
        <Box>
          <FormLabel>
            Date of Birth
            <TodayIcon fontSize="inherit" color="action" />
          </FormLabel>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="dob-date-label">Date</InputLabel>
                <Select
                  labelId="dob-date-label"
                  id="dob-date"
                  value={date}
                  label="Date"
                  onChange={dateChange}
                  style={{ borderRadius: "14px" }}
                >
                  {Array.from({ length: 31 }, (_, index) => (
                    <MenuItem key={index + 1} value={index + 1}>
                      {index + 1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="dob-month-label">Month</InputLabel>
                <Select
                  labelId="dob-month-label"
                  id="dob-month"
                  value={month}
                  label="Month"
                  onChange={monthChange}
                  style={{ borderRadius: "14px" }}
                >
                  {months.map((monthName, index) => (
                    <MenuItem key={index + 1} value={index + 1}>
                      {monthName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="dob-year-label">Year</InputLabel>
                <Select
                  labelId="dob-year-label"
                  id="dob-year"
                  value={year}
                  label="Year"
                  onChange={yearChange}
                  style={{ borderRadius: "14px" }}
                >
                  {years.map((yearValue) => (
                    <MenuItem key={yearValue} value={yearValue}>
                      {yearValue}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        {/* Gender Selection */}
        <Box>
          <FormLabel>
            Gender
            <PersonSearchIcon fontSize="inherit" color="action" />
          </FormLabel>
          <RadioGroup
            row
            aria-label="gender"
            name="gender"
            value={gender}
            onChange={handleGenderChange}
          >
            <FormControlLabel
              value="male"
              control={<Radio />}
              label="Male"
            />
            <FormControlLabel
              value="female"
              control={<Radio />}
              label="Female"
            />
            <FormControlLabel
              value="other"
              control={<Radio />}
              label="Other"
            />
          </RadioGroup>
        </Box>

        {/* Qualification Dropdown */}
        <Box>
          <FormLabel>
            Qualification
            <AutoStoriesIcon fontSize="inherit" color="action" />
          </FormLabel>
          <FormControl fullWidth>
            <InputLabel id="qualification-label">Choose Qualification</InputLabel>
            <Select
              labelId="qualification-label"
              id="qualification"
              value={qualification}
              label="Choose Qualification"
              onChange={handleQualificationChange}
              style={{ borderRadius: "14px" }}
            >
              <MenuItem value="">Choose Your Qualification</MenuItem>
              <MenuItem value="B.sc nursing ">B.sc nursing </MenuItem>
              <MenuItem value="M.sc nursing ">M.sc nursing </MenuItem>
              <MenuItem value="Others">Others</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Buttons Grid */}
        <Box style={{ display: "flex", gap: "16px", marginTop: "24px", justifyContent: "flex-end" }}>
          <SecondaryButton
            onClick={CancelBtn}
            style={{ height: "46px", borderRadius: "14px", minWidth: "120px" }}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton
            onClick={handleClickOpen}
            style={{ height: "46px", borderRadius: "14px", minWidth: "120px" }}
          >
            Save Changes
          </PrimaryButton>
        </Box>

      </form>
    </FormCard>
  );
};

export default Editprofile;
